import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <p>{`To make this library work you need to apply the `}<inlineCode parentName="p">{`ts-auto-mock`}</inlineCode>{` transformer at compile time.`}</p>
    <p>{`Unfortunately, TypeScript itself does not currently provide any easy way to use custom transformers out of the box.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Microsoft/TypeScript/issues/14419"
      }}>{`See this TypeScript issue`}</a>{`.`}</p>
    <p>{`There are different ways to do this depending on how you are currently compiling your TypeScript files`}</p>
    <h2 {...{
      "id": "jest--ts-jest--ttypescript"
    }}><inlineCode parentName="h2">{`jest`}</inlineCode>{` + `}<inlineCode parentName="h2">{`ts-jest`}</inlineCode>{` + `}<inlineCode parentName="h2">{`ttypescript`}</inlineCode></h2>
    <h3 {...{
      "id": "steps"
    }}>{`Steps`}</h3>
    <ol>
      <li parentName="ol">{`Install the dependencies`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`npm install jest ts-jest typescript ttypescript jest-ts-auto-mock ts-auto-mock
`}</code></pre>
    <p>{`you need to have `}<inlineCode parentName="p">{`ttypescript`}</inlineCode>{` installed to patch and enable the TypeScript-runtime to apply the transformer.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add the transformer to your `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode></li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`  ...
  "compilerOptions": {
    ...
    "plugins": [
      {
        "transform": "ts-auto-mock/transformer",
        "cacheBetweenTests": false
      }
    ]
    ...
  }
  ...
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Remember to set `}<inlineCode parentName="p">{`cacheBetweenTests`}</inlineCode>{` to `}<inlineCode parentName="p">{`false`}</inlineCode>{` because Jest runs tests in parallel and ts-auto-mock doesn't yet support caching across parallel tests`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can find a JSON example `}<a parentName="p" {...{
            "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/tsconfig.json"
          }}>{`here`}</a></p>
      </li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`ts-jest`}</inlineCode>{` to the transformation pattern in the Jest config`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson--jestconfigjs-without-the-jest-scope"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode>{` / `}<inlineCode parentName="strong">{`jest.config.js`}</inlineCode>{` (without the `}<inlineCode parentName="strong">{`jest`}</inlineCode>{` scope)`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "jest": {
    "transform": {
      ".(ts|tsx)": "ts-jest"
    }
  }
...
`}</code></pre>
    <ul>
      <li parentName="ul">{`You can find a JSON example `}<a parentName="li" {...{
          "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/package.json"
        }}>{`here`}</a></li>
    </ul>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`ttypescript`}</inlineCode>{` to be used as `}<inlineCode parentName="li">{`ts-jest`}</inlineCode>{` compiler`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson--jestconfigjs-without-the-jest-scope-1"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode>{` / `}<inlineCode parentName="strong">{`jest.config.js`}</inlineCode>{` (without the `}<inlineCode parentName="strong">{`jest`}</inlineCode>{` scope)`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "jest": {
    "transform": {
        "^.+\\\\.tsx?$": [
          "ts-jest",
          {
            "compiler": "ttypescript"
          }
        ]
    }
  }
...
`}</code></pre>
    <ul>
      <li parentName="ul">{`You can find a JSON example `}<a parentName="li" {...{
          "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/package.json"
        }}>{`here`}</a></li>
    </ul>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`jest-ts-auto-mock`}</inlineCode>{` config file as your setup file`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson--jestconfigjs-without-the-jest-scope-2"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode>{` / `}<inlineCode parentName="strong">{`jest.config.js`}</inlineCode>{` (without the `}<inlineCode parentName="strong">{`jest`}</inlineCode>{` scope)`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "jest": {
    "setupFiles": [
      "<rootDir>config.ts"
    ]
  }
...
`}</code></pre>
    <h4 {...{
      "id": "configts"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`config.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import 'jest-ts-auto-mock';
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/config.ts"
      }}>{`Example`}</a></p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Create your first test`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Interface {
  a: string;
  b: number;
}

describe('reuse', () => {
  let mock: Interface;

  beforeEach(() => {
    mock = createMock<Interface>();
  });

  it('should work', () => {
    expect(mock.a).toBe('');
  });
});

`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Run your test`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "scripts": {
    ...
    "test": "jest"
    ...
  }
...
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm run test
`}</code></pre>
    <p>{`... and you are all done!`}</p>
    <h3 {...{
      "id": "config-options"
    }}>{`Config options`}</h3>
    <p>{`In the tsconfig.json you can add the config options next to the transformer name:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"plugins": [
  {
    "transform": "ts-auto-mock/transformer",
    "cacheBetweenTests": false,
    "features": ["random"]
  }
]
`}</code></pre>
    <h2 {...{
      "id": "jest--ts-jest--ts-patch"
    }}><inlineCode parentName="h2">{`jest`}</inlineCode>{` + `}<inlineCode parentName="h2">{`ts-jest`}</inlineCode>{` + `}<inlineCode parentName="h2">{`ts-patch`}</inlineCode></h2>
    <h3 {...{
      "id": "steps-1"
    }}>{`Steps`}</h3>
    <ol>
      <li parentName="ol">{`Install the dependencies`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`npm install jest ts-jest typescript ts-patch jest-ts-auto-mock ts-auto-mock
`}</code></pre>
    <p>{`you need to have `}<inlineCode parentName="p">{`ts-patch`}</inlineCode>{` installed to patch and enable the TypeScript-runtime to apply the transformer.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add the transformer to your `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode></li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`  ...
  "compilerOptions": {
    ...
    "plugins": [
      {
        "transform": "ts-auto-mock/transformer",
        "cacheBetweenTests": false
      }
    ]
    ...
  }
  ...
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Remember to set `}<inlineCode parentName="p">{`cacheBetweenTests`}</inlineCode>{` to `}<inlineCode parentName="p">{`false`}</inlineCode>{` because Jest runs tests in parallel and ts-auto-mock doesn't yet support caching across parallel tests`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can find a JSON example `}<a parentName="p" {...{
            "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/tsconfig.json"
          }}>{`here`}</a></p>
      </li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`ts-jest`}</inlineCode>{` to the transformation pattern in the Jest config`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson--jestconfigjs-without-the-jest-scope-3"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode>{` / `}<inlineCode parentName="strong">{`jest.config.js`}</inlineCode>{` (without the `}<inlineCode parentName="strong">{`jest`}</inlineCode>{` scope)`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "jest": {
    "transform": {
      ".(ts|tsx)": "ts-jest"
    }
  }
...
`}</code></pre>
    <ul>
      <li parentName="ul">{`You can find a JSON example `}<a parentName="li" {...{
          "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/package.json"
        }}>{`here`}</a></li>
    </ul>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`ts-patch install`}</inlineCode>{` to your prepare script in the package json`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson-1"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "scripts": {
    ...,
    "prepare": "ts-patch install -s",
    ...
  }
...
`}</code></pre>
    <ul>
      <li parentName="ul">{`You can find a JSON example `}<a parentName="li" {...{
          "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ts-patch/package.json#L9"
        }}>{`here`}</a></li>
    </ul>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`jest-ts-auto-mock`}</inlineCode>{` config file as your setup file`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson--jestconfigjs-without-the-jest-scope-4"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode>{` / `}<inlineCode parentName="strong">{`jest.config.js`}</inlineCode>{` (without the `}<inlineCode parentName="strong">{`jest`}</inlineCode>{` scope)`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "jest": {
    "setupFiles": [
      "<rootDir>config.ts"
    ]
  }
...
`}</code></pre>
    <h4 {...{
      "id": "configts-1"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`config.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import 'jest-ts-auto-mock';
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/jest-ts-auto-mock/blob/master/examples/ts-jest-ttypescript/config.ts"
      }}>{`Example`}</a></p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Create your first test`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Interface {
  a: string;
  b: number;
}

describe('reuse', () => {
  let mock: Interface;

  beforeEach(() => {
    mock = createMock<Interface>();
  });

  it('should work', () => {
    expect(mock.a).toBe('');
  });
});

`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Run your test`}</li>
    </ol>
    <h4 {...{
      "id": "packagejson-2"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`package.json`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`...
  "scripts": {
    ...
    "test": "jest"
    ...
  }
...
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`npm run test
`}</code></pre>
    <p>{`... and you are all done!`}</p>
    <h3 {...{
      "id": "config-options-1"
    }}>{`Config options`}</h3>
    <p>{`In the tsconfig.json you can add the config options next to the transformer name:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"plugins": [
  {
    "transform": "ts-auto-mock/transformer",
    "cacheBetweenTests": false,
    "features": ["random"]
  }
]
`}</code></pre>
    <h2 {...{
      "id": "webpack"
    }}>{`Webpack`}</h2>
    <p>{`With Webpack, You can use any TypeScript-related loader that supports custom transformers, e.g. `}<inlineCode parentName="p">{`awesome-typescript-loader`}</inlineCode>{` or `}<inlineCode parentName="p">{`ts-loader`}</inlineCode>{`:`}</p>
    <h3 {...{
      "id": "steps-2"
    }}>{`Steps`}</h3>
    <h4 {...{
      "id": "webpackconfigjs"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`webpack.config.js`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const tsAutoMockTransformer = require('ts-auto-mock/transformer').default;

module.exports = {
  // ...
  module: {
    rules: [
      {
        test: /\\.ts$/,
        loader: 'ts-loader', // or 'awesome-typescript-loader'
        options: {
          getCustomTransformers: program => ({
              before: [
                  tsAutoMockTransformer(program)
              ]
          })
        }
      }
    ]
  }
};
`}</code></pre>
    <h3 {...{
      "id": "config-options-2"
    }}>{`Config options`}</h3>
    <p>{`In webpack.config.js you can pass a second parameter to the transformer:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`before: [
  tsAutoMockTransformer(program, {
    features: ['random']
  })
]
`}</code></pre>
    <h2 {...{
      "id": "ttypescript"
    }}>{`ttypescript`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/cevek/ttypescript/blob/master/README.md"
      }}>{`ttypescript's README`}</a>{` for more information`}</p>
    <h3 {...{
      "id": "steps-3"
    }}>{`Steps`}</h3>
    <h4 {...{
      "id": "tsconfigjson"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`tsconfig.json`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "compilerOptions": {
    //...,
    "plugins": [
      { "transform": "ts-auto-mock/transformer" }
    ]
  },
  //...
}
`}</code></pre>
    <h3 {...{
      "id": "config-options-3"
    }}>{`Config options`}</h3>
    <p>{`In the tsconfig.json you can add the config options next to the transformer name:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"plugins": [
  {
    "transform": "ts-auto-mock/transformer",
    "cacheBetweenTests": false,
    "features": ["random"]
  }
]
`}</code></pre>
    <h2 {...{
      "id": "ts-patch"
    }}>{`ts-patch`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/nonara/ts-patch/blob/master/README.md"
      }}>{`ts-patch's README`}</a></p>
    <h3 {...{
      "id": "steps-4"
    }}>{`Steps`}</h3>
    <p>{`Command to run to install it:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm i ts-patch
ts-patch install
`}</code></pre>
    <p>{`tsconfig.json`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "compilerOptions": {
    //...,
    "plugins": [
      { "transform": "ts-auto-mock/transformer" }
    ]
  },
  //...
}
`}</code></pre>
    <h3 {...{
      "id": "config-options-4"
    }}>{`Config options`}</h3>
    <p>{`In the tsconfig.json you can add the config options next to the transformer name:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"plugins": [
  {
    "transform": "ts-auto-mock/transformer",
    "cacheBetweenTests": false,
    "features": ["random"]
  }
]
`}</code></pre>
    <h2 {...{
      "id": "ts-node--mocha"
    }}>{`ts-node + Mocha`}</h2>
    <h3 {...{
      "id": "steps-5"
    }}>{`Steps`}</h3>
    <h4 {...{
      "id": "tsnodejs"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`tsnode.js`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const tsAutoMockTransformer = require('ts-auto-mock/transformer').default;

require('ts-node').register({
  transformers: program => ({
    before: [
      tsAutoMockTransformer(program)
    ]
  })
});
`}</code></pre>
    <p>{`Then inject the registration with the `}<inlineCode parentName="p">{`--require`}</inlineCode>{` flag that Mocha passes on to Node.js:`}</p>
    <pre><code parentName="pre" {...{}}>{`mocha --require './tsnode.js' --watch-extensions ts,tsx "test/**/*.{ts,tsx}"
`}</code></pre>
    <h3 {...{
      "id": "config-options-5"
    }}>{`Config options`}</h3>
    <p>{`In tsnode.js you can pass a second parameter to the transformer:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`before: [
  tsAutoMockTransformer(program, {
    features: ['random']
  })
]
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      